import {
  GOVERNMENT_HELP_ARTICLES,
  GOVERNMENT_HELP_CATEGORIES,
  governmentArticlesInCategory,
} from "@/lib/government-help/articles";
import { searchGovernmentHelpArticles } from "@/lib/government-help/search";
import type { HelpPortalSource } from "@/lib/help-portal";

export {
  GOVERNMENT_HELP_ARTICLES,
  GOVERNMENT_HELP_ARTICLE_IDS,
  GOVERNMENT_HELP_CATEGORIES,
  getGovernmentHelpArticle,
  isGovernmentHelpArticleId,
  governmentArticlesInCategory,
} from "@/lib/government-help/articles";
export { searchGovernmentHelpArticles } from "@/lib/government-help/search";
export type { GovernmentHelpArticleId } from "@/lib/government-help/articles";

export const GOVERNMENT_HELP_PORTAL: HelpPortalSource = {
  articles: GOVERNMENT_HELP_ARTICLES,
  categories: GOVERNMENT_HELP_CATEGORIES,
  searchArticles: searchGovernmentHelpArticles,
  articlesInCategory: governmentArticlesInCategory,
  indexTo: "/government/help",
  articleTo: "/government/help/$articleId",
  emptySearchHint:
    "Try a different word, such as compliance, needs attention, registrations, or upload.",
};
